import { put, select, takeEvery } from 'redux-saga/effects';
import { setProjectData } from './reducer';
import type { RootState } from 'store';
import { setFileHasBeenEdited } from 'store/fileState/reducer';
import { StorageUnitStatus } from 'store/storageunits/types';
import { getCurrentFile } from 'store/storageunits/selectors';

// Handle cross-slice coordination for documentMetadata
// - Listen to setFileHasBeenEdited(true) from fileState
// - Clear approvedBy when file is edited
// - Update revisedBy based on userName

function* handleFileEdited(action: ReturnType<typeof setFileHasBeenEdited>) {
  const fileHasBeenEdited = action.payload;

  if (fileHasBeenEdited) {
    const currentFile: { status: StorageUnitStatus[] } =
      yield select(getCurrentFile);
    if (currentFile.status.includes(StorageUnitStatus.APPROVED)) {
      return;
    }

    const { projectData } = yield select(
      (state: RootState) => state.documentMetadata,
    );

    const newApprovedBy = '';
    const newRevisedBy =
      projectData.drawnBy !== projectData.userName ? projectData.userName : '';

    // Only dispatch if something actually changed to prevent circular dependencies
    if (
      projectData.approvedBy !== newApprovedBy ||
      projectData.revisedBy !== newRevisedBy
    ) {
      const updatedProjectData = {
        ...projectData,
        approvedBy: newApprovedBy,
        revisedBy: newRevisedBy,
      };

      yield put(setProjectData(updatedProjectData));
    }
  }
}

function* documentMetadataSagas() {
  yield takeEvery(setFileHasBeenEdited.type, handleFileEdited);
}

export default documentMetadataSagas;
